import React from "react"
import styled from "@emotion/styled"
import { deviceMinW } from "../../styles/mediaQueries"
import { spacer } from "../../styles/sizes"
import { fontSize } from "../../styles/fonts/fontStyle"
import { motion } from "framer-motion"

const Sidebar = ({ copy, isAbout, fontColor }) => {
    return (
        <>
            <SideBarOuterContainer>
                <SidebarInnerContainer>
                    <SidebarText fontColor={fontColor} isAbout={isAbout}>
                        {copy}
                    </SidebarText>
                </SidebarInnerContainer>
            </SideBarOuterContainer>
        </>
    )
}

export default Sidebar

const SideBarOuterContainer = styled.div`
    @media ${deviceMinW.mobileXL} {
        position: absolute;
    }
`

const SidebarText = styled.span`
    color: ${props => props.fontColor};
    font-size: ${fontSize.pica};
    line-height: 1;
    transition: color 0.5s ease-in;
    will-change: color;

    @media ${deviceMinW.mobileXL} {
        display: inline-block;
        vertical-align: middle;
    }

    @media ${deviceMinW.tablet} {
        font-size: ${fontSize.doublePica};
    }
`

const SidebarInnerContainer = styled.div`
    position: relative;
    margin-bottom: ${spacer.m};

    @media ${deviceMinW.mobileXL} {
        display: block;
        position: fixed;
        bottom: ${spacer.l};
        writing-mode: vertical-rl;
        transform: rotate(180deg);
        text-align: right;
        top: inherit;
        text-orientation: sideways-right;
    }
`
